import React from 'react'
import { Status, IconButton } from  '../../../components'
import { recipeStatuses, convertServings, recipeDifficulties }  from '../../../common/recipe'
import { DeleteIcon, EditIcon, LockIcon } from '../../../components/icons'
import { cellImageStyle } from '../../../styles/common'

import S from './styled'
const EditButtons = ({ children }) => <S.EditButtons>{children}</S.EditButtons>

const lockStyle = {
  maxWidth: '40px',
  width: '40px',
  color: 'red',
  textAlign: 'center',
}

const lockBlockStyle = {
  fontSize: '22px',
  padding: '8px',
  minHeight: '24px',
  display: 'block',
}

export default ({ onEdit, handleDelete }) => [
  {
    name: 'Recipe Main Image',
    value: item => item.image ? (
      <div style={cellImageStyle(item.image)} alt="Ingredient">
        &nbsp;
      </div>
    ) : <div style={{
      minHeight: '42px',
    }}>&nbsp;</div>,
    noPadding: true,
    center: true,
  },
  {
    name: 'Unique Recipe Name',
    value: item => item.name || '-',
    sorted: true,
    sortedFieldName: 'name',
  },
  {
    name: 'Status',
    value: item => (
      <Status
        value={item.status}
        statuses={recipeStatuses}
        compact
        noActions
      />
    ),
    noPadding: true,
    style: {
      maxWidth: '90px',
    },
    sorted: true,
    sortedFieldName: 'status',
    circularSort: Reflect.ownKeys(recipeStatuses),
  },
  {
    name: 'Version',
    value: item => item.version || '-',
  },
  {
    name: 'Difficulty',
    value: item => (recipeDifficulties[item.difficulty] || { name: '-' }).name,
    sorted: true,
    sortedFieldName: 'difficulty',
    circularSort: Reflect.ownKeys(recipeDifficulties),
  },
  {
    name: 'Servings',
    value: item => convertServings(item.servings) || '-',
  },
  {
    name: 'Locked',
    value: item => item.editLock && item.editLock.isLocked ?
      <div style={lockBlockStyle}><LockIcon /></div> : <span style={lockBlockStyle}>&nbsp;</span>,
    style: lockStyle,
    noPadding: true,
  },
  {
    name: '',
    value: item => (
      <EditButtons>
        <IconButton onClick={() => onEdit(item)}><EditIcon /></IconButton>
        <IconButton onClick={() => handleDelete(item)} red><DeleteIcon /></IconButton>
      </EditButtons>
    ),
    style: {
      maxWidth: '60px',
    },
    noPadding: true,
  },
]
